import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-444f8220")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: [_ctx.iconHeight + ' ' + _ctx.iconWidth + ' ' + _ctx.iconColor + ' ' + _ctx.cssClass],
    innerHTML: _ctx.iconSrc
  }, null, 10, ["innerHTML"]))
})